import { useEffect } from 'react'
import RouletteWheel from '../RouletteSystem/RouletteWheel'

interface BroUser {
  id: string
  telegram_id: string
  brocode: string
  rank: string
  bro_score: number
  is_brometheus: boolean
  twitter_handle?: string
}

interface MiniAppRouletteProps {
  user: BroUser
}

const MiniAppRoulette = ({ user }: MiniAppRouletteProps) => {
  useEffect(() => {
    console.log(`🎰 [ROULETTE DEBUG] User data:`, user);
    console.log(`🎰 [ROULETTE DEBUG] localStorage auth state:`, {
      connected_wallet_address: localStorage.getItem('connected_wallet_address'),
      bromentum_wallet_address: localStorage.getItem('bromentum_wallet_address'),
      walletAddress: localStorage.getItem('walletAddress'),
      brocode: localStorage.getItem('brocode'),
      user_brocode: localStorage.getItem('user_brocode')
    });
  }, [user]);

  return (
    <RouletteWheel 
      currentXP={user.bro_score || 0}
    />
  )
}

export default MiniAppRoulette